// StatusFilterBar.js
import React, { useCallback } from 'react';
import {
  FaHourglassHalf,
  FaBookmark,
  FaTrophy,
  FaTimesCircle,
  FaProjectDiagram,
} from 'react-icons/fa';

const statuses = [
  { label: 'INCOMPLETE', icon: <FaHourglassHalf /> }, // Combined status
  { label: 'WON', icon: <FaTrophy /> },
  { label: 'LOST', icon: <FaTimesCircle /> },
  { label: 'PIPELINE', icon: <FaProjectDiagram /> },
];

const StatusFilterBar = ({ stateFilter, setStateFilter }) => {
  // Toggle filter status
  const toggleStatus = useCallback(
    (status) => {
      let updatedFilter = [...stateFilter];
      if (status === 'INCOMPLETE') {
        const incompleteStatuses = ['PENDING', 'SAVED'];
        if (incompleteStatuses.every((s) => stateFilter.includes(s))) {
          updatedFilter = updatedFilter.filter(
            (s) => !incompleteStatuses.includes(s),
          );
        } else {
          incompleteStatuses.forEach((s) => {
            if (!updatedFilter.includes(s)) {
              updatedFilter.push(s);
            }
          });
        }
      } else {
        if (updatedFilter.includes(status)) {
          updatedFilter = updatedFilter.filter((s) => s !== status);
        } else {
          updatedFilter.push(status);
        }
      }
      setStateFilter(updatedFilter);
    },
    [stateFilter, setStateFilter],
  );

  // Handle "All" selection by clearing all filters
  const selectAll = useCallback(() => {
    setStateFilter([]); // Empty array represents "All" selected
  }, [setStateFilter]);

  return (
    <div className="flex gap-4 mb-4 ">
      <button
        onClick={selectAll}
        className={`filter-button ${stateFilter.length === 0 ? 'active' : ''}`}
      >
        All
      </button>
      {statuses.map(({ label, icon }) => (
        <button
          key={label}
          onClick={() => toggleStatus(label)}
          className={`filter-button ${
            (label === 'INCOMPLETE' &&
              ['PENDING', 'SAVED'].every((s) => stateFilter.includes(s))) ||
            stateFilter.includes(label)
              ? 'active'
              : ''
          }`}
        >
          {icon} {label}
        </button>
      ))}
    </div>
  );
};

export default StatusFilterBar;
